<div class="card border-0" style="background-color: #b2d0dc" *transloco="let t; read: 'ime.components.dashboard'">
  <div class="card-body">
    <h4 class="card-title pb-3 d-flex justify-content-between">
      <span>
        <svg viewBox="0 0 8 8" class="icon me-1" [inlineSVG]="'#code-bracket'">
        </svg>
        <a class="text-dark" [routerLink]="'../changelog'">
          {{t('Changelog')}} {{(stateService.settings$ | async)?.AppVersion}}
        </a>
      </span>
    </h4>
    <div class="bg-white p-1" [innerHTML]="changelog$ | async"></div>
  </div>
</div>
